import Box from '@mui/material/Box'
import { observer } from 'mobx-react'
import moment from 'moment'
import React from 'react'
import DataUnit from '../../../../../components/customElements/DataUnit/DataUnit'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import { formatID } from '../../../../../helpers/ordersUtiles'
import { RequestType } from '../../SingleRequest/types/Request.type'

interface NewRequestInfoAccProps {
  request: RequestType
}

const NewRequestInfoAcc: React.FC<NewRequestInfoAccProps> = ({ request }) => {
  return (
    //  @ts-ignore
    <CustomAccordion defaultOpenState summary={'Информация о заявке'}>
      <DataUnit name={'Номер заявки'} value={formatID(request)} />
      <Box mt={2}>
        <DataUnit
          name={'Дата создания'}
          value={moment(request.created).format('DD.MM.YYYY, HH:mm')}
        />
      </Box>
    </CustomAccordion>
  )
}

export default observer(NewRequestInfoAcc)
